import React from 'react';
import styles from './KanbanBoard.module.css';
import { KanbanColumn } from './KanbanColumn';

export interface ColumnDefinition<T> {
  id: string;
  title: string;
  items: T[];
  headerClassName?: string;
  emptyMessage?: string;
  emptyState?: React.ReactNode;
}

export interface KanbanBoardProps<T> {
  columns: ColumnDefinition<T>[];
  renderCard: (item: T, columnId: string) => React.ReactNode;
  emptyMessage?: string;
  variant?: 'application' | 'interview';
  'data-testid'?: string;
}

export const KanbanBoard = <T extends { id: string }>({
  columns,
  renderCard,
  emptyMessage,
  variant = 'application',
  'data-testid': testId,
}: KanbanBoardProps<T>) => {
  return (
    <div className={styles.kanbanBoard} data-testid={testId}>
      <div className={styles.kanbanColumns}>
        {columns.map((column) => (
          <KanbanColumn
            key={column.id}
            id={column.id}
            title={column.title}
            items={column.items}
            renderCard={(item) => renderCard(item, column.id)}
            headerClassName={column.headerClassName}
            emptyMessage={column.emptyMessage}
            emptyState={column.emptyState}
            variant={variant}
          />
        ))}
      </div>
    </div>
  );
};
